import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEdit = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M19.125 0.707107L23.2929 4.875L8.28152 19.8864L1.33503 22.665L4.11362 15.7185L19.125 0.707107Z",
		stroke: "currentColor",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("rect", {
		x: 15.875,
		y: 3.25,
		width: 6.89429,
		height: 1.14905,
		transform: "rotate(45 15.875 3.25)",
		fill: "currentColor"
	})]
});
export default SvgEdit;
